module.exports = __webpack_public_path__ + "img/Whipworm.2ed38ee7.png";